import React, {Component} from 'react';
import {computeDuration, formatTime, uuid} from "../../../../../utils";
import BaseComponent from "../../../../../base/BaseComponent";
import close from "../close.png";
import {Tooltip} from "antd";
import $ from "jquery";

class Audio extends BaseComponent {
    state = {
        checked: false
    };

    //选中的话就返回item
    checkedAndReturn(){
        if(this.state.checked){
            return this.props.data;
        }
    }

    cancelChecked(){
        this.setState({checked: false});
    }

    render() {
        let {data} = this.props;
        let pStyle = {marginBottom:0,cursor:"default",color:"#bcbdbf"};
        let blockWidth = 280;
        let imgWidth = 80;
        let margin = 10;
        let viewAttr = this.sysConfigGetValueByKey("resource.dialog.audio.detail.view.attr", "icon");
        let playAttr = this.sysConfigGetValueByKey("resource.dialog.audio.detail.play.attr", "path");
        return (
            <div>
                <div style={{margin,marginTop:0,borderRadius:5,width:blockWidth,float:"left",background:"#eff5fd",border:`1px solid ${this.state.checked?this.themeBgColor:"#fff"}`}}
                    onClick={()=>{
                    let checked = !this.state.checked;
                    this.state.checked = checked;
                    this.setState({});
                    this.props.onClick && this.props.onClick(data, checked);
                }}>
                    <table width={"100%"} height={100} cellPadding={margin} cellSpacing={0} border={0}><tbody><tr>
                        <td><img src={data[viewAttr]?data[viewAttr]:data.icon} style={{borderRadius:5,objectFit:"cover"}} height={imgWidth} width={imgWidth} /></td>
                        <td>
                            <p style={{fontSize:14, ...pStyle, color:"#787474", width:blockWidth - imgWidth - margin * 2 - margin * 3}} className={"text-pointer"}>
                                <Tooltip placement={"topLeft"} title={data.name}><b>{data.name}</b></Tooltip></p>
                            <p style={pStyle}>来源：{data.source}</p>
                            <p style={pStyle}>日期：{formatTime(data.createTime)}</p>
                            <p style={pStyle}>时长：{computeDuration(data.duration)}<span onClick={(e)=>{
                                this.detailDialog.show();
                                e.stopPropagation();
                            }} style={{float:"right",cursor:"pointer",color:this.themeBgColor}}>播放</span></p>
                        </td>
                    </tr></tbody></table>
                </div>
                <DetailDialog ref={detailDialog=>this.detailDialog=detailDialog} path={data[playAttr]} />
            </div>
        );
    }
}

export class DetailDialog extends BaseComponent{
    state = {
        show: false,
    }

    id = "b"+uuid();

    show = ()=>{
        $(`#${this.id}`).show();
        this.state.show = true;
        this.setState({});
    };

    hide = ()=>{
        $(`#${this.id}`).hide();
        this.state.show = false;
        this.setState({});
    };

    render() {
        let videoMaxWidth = document.body.clientWidth * 0.8;
        let videoMaxHeight = document.body.clientHeight * 0.8;
        return <div id={this.id} style={{display:"none"}}>
            <div style={{position:"fixed", top:0, left:0, zIndex:9998, opacity:0.4, background:"#000",width:document.body.clientWidth,height:document.body.clientHeight}} />
            <table style={{position:"fixed", top:0, left:0, zIndex:9999}} width={document.body.clientWidth} height={document.body.clientHeight} cellSpacing={0} cellPadding={0} border={0}><tbody><tr><td valign={"middle"} align={"center"}>
                {!this.state.show?"":<audio src={this.props.path} style={{maxWidth:videoMaxWidth,maxHeight:videoMaxHeight}} controls={true} controlsList={"nodownload"}/>}
                <img onClick={(e)=>{
                    this.hide();
                    e.stopPropagation();
                }} src={close} style={{position:"fixed", top:100, right:100, width:88, height:88, cursor:"pointer"}} />
            </td></tr></tbody></table>
        </div>
    }
}
export default Audio;